<template>
  <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120" style="width:40%">
    <FormItem label="升级包名称" prop="name" inline>
      <Input v-model="formValidate.name" placeholder=""/>
    </FormItem>

    <Upload action="" ref="upload" :before-upload="handleUpload" style="margin-left:120px;margin-top: -5px;">
      <Button icon="ios-cloud-upload-outline">浏览</Button>
    </Upload>

    <FormItem label="升级包类型" prop="uploadType" inline>
      <Select v-model="formValidate.uploadType" placeholder="请选择指定基础版本"
              @on-change="uploadTypeChange">
        <Option v-for="(item, index) in uploadTypelist"
                :key="item.value"
                :label="item.label"
                :value=item.value>
          {{item.label}}
        </Option>
      </Select>
    </FormItem>



    <FormItem label="云服务器" prop="ftpId">
      <Select v-model="formValidate.ftpId" placeholder="请选择服务器">
        <Option v-for="(item, index) in ftpList" :key="index" :value="item.id">{{item.ftpName}}</Option>

      </Select>
    </FormItem>
    <FormItem label="设备型号" prop="deviceModel">
      <Input v-model="formValidate.deviceModel" placeholder="请输入设备型号"/>
    </FormItem>
    <FormItem label="BOARD ID" prop="boardId">
      <Input v-model="formValidate.boardId" placeholder="请输入BOARD ID"/>
    </FormItem>
    <FormItem label="Device Type" prop="deviceType">
      <Input v-model="formValidate.deviceType" placeholder="请输入Device Type"/>
    </FormItem>
    <FormItem label="客户编号" prop="customer">
      <Input v-model="formValidate.customer" placeholder="请输入客户编号"/>
    </FormItem>
    <FormItem label="客户版本编号" prop="versionId">
      <Input v-model="formValidate.versionId" placeholder="请输入客户版本编号"/>
    </FormItem>
    <FormItem label="版本" prop="version">
      <Input v-model="formValidate.version" placeholder="请输入版本号"/>
    </FormItem>

    <FormItem label="指定基础版本"  v-if="formValidate.uploadType == 0">
      <Input v-model="formValidate.baseversion" placeholder="请输入指定基础版本" style="width: 30%"/>

      <Select v-model="formValidate.baseversiononelist" placeholder="请选择指定基础版本" style="width: 30%;margin-left: 10%"
              @on-change="versionchange" v-if="ishavebordId">
        <Option v-for="(item, index) in baseversionList" :key="index"
                :value=item>
          {{item}}
        </Option>
      </Select>
      <Button type="primary" icon="ios-search" @click="selectbaseversion" style="width: 20%;margin-left: 10%"
              v-if="ishavebordId">查询
      </Button>
    </FormItem>
<!---->
    <!--<div style="color: red;float: left;padding-left: -20px;padding-top: 10px;" v-if="formValidate.uploadType == 1">*</div>-->
    <FormItem label="指定固件基础版本"  v-if="formValidate.uploadType == 1" prop="baseversiononelistTwo">

      <Select v-model="formValidate.baseversiononelistTwo" placeholder="请选择指定固件基础版本" style="width: 30%;"
              @on-change="versionchange" >
        <Option v-for="(item, index) in algorithmVersionList" :key="index"
                :value=item>
          {{item}}
        </Option>
      </Select>
      <Button type="primary" icon="ios-search" @click="selectalgorithmList" style="width: 20%;margin-left: 8%"
              v-if="ishavebordIdTwo">查询
      </Button>

      <!--<div style="color: red;margin-left: 7%;display: inline-block;margin-top: 0px;" v-if="formValidate.uploadType == 1">*</div>
      <Select v-model="formValidate.algorithmType" placeholder="请选择算法类型" style="width: 30%;margin-left: 2%;">
        <Option v-for="(item, index) in algorithmList" :key="index"
                :value=item>
          {{item}}
        </Option>
      </Select>-->
    </FormItem>
    <!--<div style="color: red;float: left;padding-left: -60px;padding-top: 10px;margin-left: 50px;" v-if="formValidate.uploadType == 1">*</div>-->
    <FormItem label="算法类型" prop="algorithmType" class="algorithmType" v-if="formValidate.uploadType == 1">
      <Select v-model="formValidate.algorithmType" placeholder="请选择算法类型" style="width: 30%;">
        <Option v-for="(item, index) in algorithmList" :key="index"
                :value=item>
          {{item}}
        </Option>
      </Select>
    </FormItem>

    <FormItem label="升级包语言" prop="lang">
      <Select v-model="formValidate.lang" placeholder="请选择升级包语言" multiple>
        <Option v-for="(item, index) in langs" :key="index" :value="item.value" :disabled="disabled">
          {{item.name}}
        </Option>
        <!--<option :value="all">所有</option>-->
      </Select>
    </FormItem>
    <FormItem
      v-for="(item, index) in selLang"
      :key="index"
      :label="item.label">
      <Row>
        <Col span="18">
        <Input type="textarea" v-model="item.desc" placeholder="请输入版本描述"/>
        </Col>
        <Col span="4" offset="1">
        <Button @click="handleRemove(index)">删除</Button>
        </Col>
      </Row>
    </FormItem>
    <FormItem>
      <Row>
        <Col span="18">
        <Select v-model="lang" :label-in-value="true" @on-change="v=>{ setOption(v)}">
          <Option v-for="(item,index) in langList" :value="item.value" :key="index">{{ item.label }}</Option>
        </Select>
        </Col>
        <Col span="4" style="margin-left:20px;" v-if="isshowadd">
        <Button type="dashed" long @click="handleAdd" icon="md-add">添加</Button>
        </Col>
      </Row>
    </FormItem>
    <FormItem>

      <!--:loading="loading"-->
      <Button type="primary" @click="handleSubmit('formValidate')" >上传
        <!--<span v-if="!loading">上传</span>-->
        <!--<span v-else>上传中</span>-->
      </Button>
      <Button @click="handleReset('formValidate')" style="margin-left: 8px">重置</Button>
    </FormItem>
  </Form>
</template>
<script>
// eslint-disable-next-line indent
  /* eslint-disable no-useless-escape,indent,indent */

  import {getdeviceversion,deviceAlgorithmVersion,deviceAlgorithmList, uploadTableData, getFtpList, getLauage} from '@/api/data'
export default {
  data () {
    const validateDealerNumber = (rule, value, callback) => {
      let reg2 = /[^a-z|A-Z|0-9|\-|\+|_|\.]/g
      if (reg2.test(value)) {
        callback(new Error('设备型号不允许输入特殊符号和汉字'))
      } else {
        callback()
      }
    }

    const validateVersion = (rule, value, callback) => {
      let reg = /^([1-9]\d{1,2}|[1-9])(.([1-9]\d{1,2}|\d)){2,3}-\d{1,10}$/;
      console.log(666);
      if (!reg.test(value)) {
        callback(new Error('版本号格式不正确'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      disabled: false,
      flag: true,
      file: null,
      ishavebordId: false,
      ishavebordIdTwo: false,
      isshowadd: false,
      lang: 'cn',
      label: '',
      value: '',
      ftpList: [],
      selLang: [
        {label: '中文简体', value: 'cn', desc: ''}
      ],
      baseversionList: [],
      algorithmVersionList: [],
      algorithmList: [],
      uploadTypelist: [{
        value: '0',
        label: '固件升级包'
      },{
        value: '1',
        label: '算法升级包'
      }],
      langs: [
        //        { value: 'SimpChinese', name: '简体中文' },
        //        { value: 'TranChinese', name: '繁体中文' },
        //        { value: 'English', name: '英语' }
      ],
      langList: [
        {label: '中文简体', value: 'cn', desc: ''},
        {label: '中文繁体', value: 'tw', desc: ''},
        {label: '英语', value: 'en', desc: ''},
        {label: '越南语', value: 'vi', desc: ''},
        {label: '日语', value: 'ja', desc: ''},
        {label: '土耳其语', value: 'tr', desc: ''},
        {label: '德语', value: 'de', desc: ''},
        {label: '意大利语', value: 'it', desc: ''},
        {label: '韩语', value: 'ko', desc: ''},
        {label: '泰国语', value: 'th', desc: ''},
        {label: '法语', value: 'fr', desc: ''},
        {label: '葡萄牙语', value: 'pt', desc: ''},
        {label: '西班牙语', value: 'es', desc: ''},
        {label: '波兰语', value: 'pl', desc: ''},
        {label: '印尼语', value: 'id', desc: ''},
        {label: '捷克语', value: 'cz', desc: ''},
        {label: '希腊语', value: 'gr', desc: ''},
        {label: '波斯语', value: 'pe', desc: ''},
        {label: '希伯来语', value: 'he', desc: ''},
        {label: '阿拉伯语', value: 'ar', desc: ''},
        {label: '俄语', value: 'ru', desc: ''}
      ],
      formValidate: {
        name: '',
        uploadType:'0',
        ftpId: '',
        deviceModel: '',
        boardId: '',
        deviceType: '',
        customer: '',
        versionId: '',
        version: '',
        lang: '',
        desc: '',
        baseversion: '',
        baseversiononelist: '',
        baseversiononelistTwo:'',
        algorithmType:''
      },
      ruleValidate: {
        name: [
          {required: true, message: '请选择升级包', trigger: 'input'},
          {type: 'string', min: 8, message: '升级包语言名称不少于8个字符', trigger: 'blur'}
        ],
        uploadType: [
          {required: true, message: '请选择升级包类型', pattern: /.+/, trigger: 'change'}
          ],
        ftpId: [
          {required: true, message: '请选择云服务器', pattern: /.+/, trigger: 'change'}
        ],
        deviceModel: [
          {required: true, trigger: 'blur', message: '请输入设备型号'},
          {validator: validateDealerNumber, trigger: 'blur'}
        ],
        boardId: [
          {required: true, message: '请输入board id', trigger: 'blur'}
        ],
        deviceType: [
          {required: true, message: '请输入device type', trigger: 'blur'}
        ],
        customer: [
          {required: true, message: '请输入客户编号', trigger: 'blur'}
        ],
        versionId: [
          {required: true, message: '请输入客户版本编号', trigger: 'blur'}
        ],

        /**/
        version: [
          {required: true,  trigger: 'blur', message: '请输入版本号'},
          {validator: validateVersion, trigger: 'blur'}
        ],
        // baseversiononelistTwo:[
        //   {required: true, message: '请选择指定固件基础版本', pattern: /.+/, trigger: 'change'}
        // ],
        lang: [
          {required: true, message: '请选择升级包语言', pattern: /.+/, trigger: 'change'}
        ],
        desc: [
          {required: true, message: '请输入版本描述', trigger: 'blur'},
          {type: 'string', min: 20, message: '', trigger: 'blur'}
        ]
      }
    }
  },
  // 表单页面监听
  watch: {
    'formValidate.lang': {
      handler: function (val) {
        if (val.indexOf('All') != -1) {
          this.disabled = true
        } else {
          this.disabled = false
        }
      }
    },

    formValidate: {
      handler: function (val) {
        if (val.boardId != '' && val.deviceType != '') {
          this.ishavebordId = true
        } else {
          this.ishavebordId = false
        }
        if (val.boardId != '' && val.deviceType != '' && val.customer != '' && val.versionId != '') {
          this.ishavebordIdTwo = true
        } else {
          this.ishavebordIdTwo = false
        }
      },
      deep: true
    },

    'lang': {
      handler: function (val) {
        if (val != '') {
          this.isshowadd = true
        } else {
          this.isshowadd = false
        }
      }
    }

  },

  created () {
    this.handleListFtp()
    this.handleGetLau()
  },
  methods: {
    versionchange (val) {
      this.formValidate.baseversion = val
    },
    uploadTypeChange(val){
      this.formValidate.baseversiononelist = '';
    },

    selectalgorithmList(){

      let para = {}
      para.boardId = this.formValidate.boardId
      para.deviceType = this.formValidate.deviceType
      para.customer = this.formValidate.customer
      para.versionId = this.formValidate.versionId
      deviceAlgorithmVersion(para).then((res) => {
        this.baseversionList = []
        this.algorithmVersionList = res.data.data
      })

      deviceAlgorithmList().then((res) => {
        this.algorithmList = []
        this.algorithmList = res.data.data
      })




    },
    selectbaseversion () {
      this.formValidate.baseversiononelist = ''
      let para = {}
      para.boardId = this.formValidate.boardId
      para.deviceType = this.formValidate.deviceType
      getdeviceversion(para).then((res) => {
        this.baseversionList = []
        this.baseversionList = res.data.data
      })
    },
    handleUpload (file) {
      this.formValidate.name = file.name
      this.file = file
      return false
    },
    handleSubmit (name) {
      let self = this
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.loading = true
          let descList = []
          let parmarLang = []
          let formdata = new FormData()
          // if (!self.ishavebordId) {
          //   self.formValidate.baseversion = null
          // }
          formdata.append('name', self.formValidate.name)
          formdata.append('ftpId', self.formValidate.ftpId)
          formdata.append('deviceModel', self.formValidate.deviceModel)
          formdata.append('boardId', self.formValidate.boardId)
          formdata.append('deviceType', self.formValidate.deviceType)
          formdata.append('customer', self.formValidate.customer)
          formdata.append('versionId', self.formValidate.versionId)
          formdata.append('version', self.formValidate.version)
          //if(self.formValidate.uploadType == 1){
            formdata.append('uploadType', self.formValidate.uploadType)
            if(self.formValidate.uploadType == 0){
              formdata.append('baseVersion', self.formValidate.baseversion)
            }else{
              if(self.formValidate.baseversiononelistTwo == ''){
                this.$Message.error('请选择指定固件基础版本')
                return;
              }
              formdata.append('baseVersion', self.formValidate.baseversiononelistTwo)

              if(self.formValidate.algorithmType == ''){
                this.$Message.error('请选择算法类型')
                return;
              }
              formdata.append('algorithmType', self.formValidate.algorithmType)
            }
         // }



          formdata.append('file', self.file)
          for (let i = 0; i < self.selLang.length; i++) {
            let desc = {}
            desc.lang = self.selLang[i].value
            desc.desc = self.selLang[i].desc
            console.log(desc.desc)
            descList.push(desc)
          }

          formdata.append('desc', JSON.stringify(descList))
          for (let j = 0; j < self.formValidate.lang.length; j++) {
            let parla = {}
            parla.lang = self.formValidate.lang[j]
            parmarLang.push(parla)
          }
          if (parmarLang.length > 1) { // 如果选取了多个值，判断是否包含all
            for (let k = 0; k < parmarLang.length; k++) {
              if (parmarLang[k].lang == 'All') {
                parmarLang = []// 数组清空
                var item = {'lang': 'All'}
                parmarLang.push(item)// 重新赋值
              }
            }
          }
          formdata.append('lang', JSON.stringify(parmarLang))
          uploadTableData(formdata).then((res) => {
            let status = res.data.meta.success
            if (status) {
              this.$Message.success('上传数据成功!')
            } else {
              this.$Message.error(res.data.meta.message)
            }
            this.loading = false
          })
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    },
    setOption (v) {
      this.label = v.label
      this.value = v.value
    },
    handleAdd () {
      this.selLang.push({
        label: this.label,
        value: this.value
      })
    },
    handleRemove (index) {
      this.selLang.splice(index, 1)
    },
    handleListFtp () {
      getFtpList().then((res) => {
        this.ftpList = res.data.data
      })
    },

    handleGetLau () {
      getLauage().then((res) => {
        var objLangs = res.data.data
        // 将对象转换为key value的对象数组
        for (let i in objLangs) {
          let o = {value: i, name: objLangs[i]}
          this.langs.push(o)
        }
      })
    }
  }

}
</script>

<style>

  /*.algorithmType{*/
    /*margin-left: 36px;*/
  /*}*/

  /*.algorithmType .ivu-form-item-label{*/
    /*width: 66px;*/
  /*}*/

  /*.algorithmType .ivu-form-item-content{*/
    /*margin-left: 75px;*/
  /*}*/
</style>
